export default {
  0: 'Manage all features of the workspace, including workspace settings and billing.',
  1: 'Manage all features of the workspace, including workspace settings.',
  2: 'Manage all aspects of your workspace community, such as Users, Teams & Groups, and community moderation.',
  3: 'Manage learning content (Articles, Courses, and Events) within your workspace.',
  4: 'Manage all aspects of reporting within your workspace, including access to all reports and analytics.',
  5: 'Manage the assessments deployed within your workspace.',
  6: 'Engage and interact within the community, with no management capabilities over the workspace.'
}
